import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_COST_PROVIDER_RESET = 'POST_COST_PROVIDER_RESET';
export const POST_COST_PROVIDER_LOADING = 'POST_COST_PROVIDER_LOADING';
export const POST_COST_PROVIDER_SUCCESS = 'POST_COST_PROVIDER_SUCCESS';
export const POST_COST_PROVIDER_REJECT = 'POST_COST_PROVIDER_REJECT';

//* ACTIONS ------------------------------------------------
export const postCostProviderReset = () => ({ type: POST_COST_PROVIDER_RESET });
export const postCostProviderLoading = () => ({ type: POST_COST_PROVIDER_LOADING });
export const postCostProviderSuccess = (payload) => ({ type: POST_COST_PROVIDER_SUCCESS, payload });
export const postCostProviderReject = (payload) => ({ type: POST_COST_PROVIDER_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const postCostProviderRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.POST,
        data,
    }, getState);
    return request(`/Providers/web/AddProviderCosts`, options);
};


